import _ from 'lodash';
import React from 'react';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import Header from '../layout/Header.jsx';
import { useAsyncResource } from '../../../commons/hooks/useAsyncResource';
import ListResource from '../../../admin/components/lists/ListResource.jsx';
import useSearchParams from '~/commons/hooks/useSearchParams';
import { env } from '~/commons/config';

const PageShareStocks = () => {
  return (
    <div className="py-4">
      <Header>Share History</Header>
      <ListResource
        api='/api/core/shareStocks'
        actions={{
          create: false,
          remove: false,
        }}
        filter={{}}
        searchable
        sort={{ createdAt: -1 }}
        cols={[
          {
            key: 'customers',
            children: 'Customers',
            headerStyle: {
              width: '40%',
            },
            dataStyle: {
              maxWidth: 0,
            },
            dataClass: 'text-truncate',
            getter: (v) => _.compact(_.map(v, 'name.full.en')).join(', '),
          },
          {
            key: 'items',
            children: 'Total Stock Number',
            getter: (v) => _.size(v),
          },
          {
            key: 'issuedBy.name.full.en',
            sortable: true,
            children: 'Action By',
          },
          {
            key: 'createdAt',
            children: 'Action At',
            sortable: true,
            getter: (v) => moment(v).format(env.f.dt),
          },
          {
            key: '_id',
            children: 'Action',
            headerStyle: {
              width: '150px',
            },
            getter: (v, item) => (
              <a
                className="btn btn-primary"
                href={`/portal/shareStocks/new?${_.map(item.items, (i) => `items[]=${i._id}`).join('&')}`}
              >
                Share Again
              </a>
            ),
          }
        ]}
      >
        {() => (
          <a className="btn btn-primary" href="/portal/shareStocks/new">
            Share Stocks
          </a>
        )}
      </ListResource>
    </div>
  );
};

export default PageShareStocks;
